<!-- DELETE THIS -->
<div class="ch-panel-content d-flex flex-column flex-grow">
  <h3>Default folders</h3>
  <p>
    These are the initial folders that will be created in each new workspace
  </p>
  <div
    class="tracked-item-dashboard-wapper d-flex flex-column"
    style="text-align: left !important"
  >
    <div class="d-flex flex-grow">
      <div class="files-manager-columns">
        <div class="row">
          <div class="col col-md-6">
            <!-- List files -->
            <div class="files-list">
              <!-- Title -->
              <div class="files-list-header">
                <h3>Folders</h3>
              </div>
              <!-- Files and Folders -->
              <div class="file-items">
                <div
                  class="file-item"
                  title="Client Shared Folder"
                  (click)="clientSharedStaff()"
                >
                  <div class="file-icon clients-folder"></div>
                  <div class="file-name">Client Shared Folder</div>
                  <div class="file-info">{{ clientSharedCountDisplay }}</div>
                </div>
                <div
                  class="file-item"
                  title="Internal Folders"
                  (click)="staffSharedStaff()"
                >
                  <div class="file-icon staff-folder"></div>
                  <div class="file-name">Internal Folders</div>
                  <div class="file-info">{{ internalCountDisplay }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-md-6">
            <!-- List files -->
            <div class="files-list">
              <!-- Title -->
              <div class="files-list-header back">
                <i
                  class="feather arrow-left"
                  placement="right"
                  tooltip="Go back"
                  (click)="folderBackButton()"
                  *ngIf="btnFolderBackVisible"
                ></i>
                <h3 title="">
                  {{ dfTabTitle }}
                </h3>

                @if (btnFolderBackVisible) {
                <div dropdown>
                  <span
                    *dropdownToggle
                    id="folderActions"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style="margin-right: 16px"
                    ><i class="feather more-horizontal"></i
                  ></span>
                  <ul
                    *dropdownMenu
                    class="dropdown-menu dropdown-menu-end"
                    aria-labelledby="folderActions"
                  >
                    <li>
                      <a (click)="renameFolderVisible = true">Rename Folder</a>
                    </li>
                    <li>
                      <a (click)="openDeleteConfirmationModal()"
                        >Delete Folder</a
                      >
                    </li>
                  </ul>
                </div>
                }

                <button
                  class="btn btn-primary"
                  (click)="createFolderActivate()"
                >
                  Add Folder
                </button>
              </div>

              <!-- Create Default Folders -->
              <div class="file-items" *ngIf="createFolderVisible">
                <input
                  #txtCreateFolder
                  type="text"
                  class="form-control rename-file-input"
                  style="text-align: center; font-weight: 600"
                />
                <div class="row">
                  <div class="col-sm-6">
                    <button
                      class="btn btn-default btn-block"
                      (click)="createFolderVisible = false"
                    >
                      Cancel
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <button
                      class="btn btn-primary btn-block"
                      (click)="createDefaultFolder(txtCreateFolder.value)"
                    >
                      Create
                    </button>
                  </div>
                </div>
              </div>

              <!-- Rename Folders -->
              <div class="file-items" *ngIf="renameFolderVisible">
                <input
                  #txtRenameFolder
                  type="text"
                  class="form-control rename-file-input"
                  style="text-align: center; font-weight: 600"
                />
                <div class="row">
                  <div class="col-sm-6">
                    <button
                      class="btn btn-default btn-block"
                      (click)="renameFolderVisible = false"
                    >
                      Cancel
                    </button>
                  </div>
                  <div class="col-sm-6">
                    <button
                      class="btn btn-primary btn-block"
                      (click)="
                        renameDefaultFolder(
                          currentFolder.uuid,
                          txtRenameFolder.value
                        )
                      "
                    >
                      Rename
                    </button>
                  </div>
                </div>
              </div>

              <!-- Files and Folders -->
              <div class="file-items">
                <div
                  class="file-item"
                  *ngFor="let folder of currentFolder.folders; let i = index"
                  (click)="getDefaultFolder(folder.uuid)"
                >
                  <div class="file-icon regular-folder"></div>
                  <div class="file-name">{{ folder.name }}</div>
                  <div class="file-info flex-grow"></div>
                  <!-- <div class="file-delete color-red" tooltip="Delete" (click)="deleteDefaultFolder(defaultsToShow.folders[i].uuid); getFilteredDefaultFolders()">
                    <i class="feather trash-2"></i>
                  </div>
                </div>
                <div *ngFor="let folder of currentFolder.folders; let i = index" (click)="getDefaultFolder(folder.uuid)" class="file-item hoverable" title="{{ folder.foldername }}">
                <div class="file-name">{{ folder.foldername }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-md-4 shaded">
          </div>
        </div>
      </div>

      <!-- Delete folders -->
                  <ng-template #deleteModal>
                    <div
                      class="modal-header text-center"
                      style="border-bottom: none"
                    >
                      <!-- <i class="feather check-circle x3" style="color: #0084ff;"></i> -->
                      <div class="m-auto">
                        <h4>Are you sure?</h4>
                      <p>
                        You are about to delete the file
                        <strong>{{ fileDetails.filename }}</strong
                        >.<br />
                        If you want to proceed, click delete.
                        <!-- <a routerLink="/terms-of-service" target="_blank" rel="noreferrer noopener">Terms of Service</a> and
            <a routerLink="/privacy-policy" target="_blank" rel="noreferrer noopener">Privacy Policy</a>. -->
                      </p>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div
                        class="btn btn-default pull-left"
                        aria-label="Cancel"
                        (click)="bsDeleteModalRef.hide()"
                      >
                        Cancel
                      </div>
                      <div class="btn btn-danger pull-right">Delete</div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
